// Small inline icons (stroke follows currentColor).

const paths = {
  menu: "M4 6h16M4 12h16M4 18h16",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm10 17-5.2-5.2",
  refresh: "M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4",
  back: "M15 5l-7 7 7 7",
  chevron: "M9 5l7 7-7 7",
  close: "M6 6l12 12M18 6 6 18",
  trash: "M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6",
  move: "M3 7h6l2 2h10v10H3zM12 14h6m-2-2 2 2-2 2",
  unread: "M3 6h18v12H3zM3 6l9 7 9-7",
  read: "M3 10l9-6 9 6v9H3zM3 10l9 6 9-6",
  readAll: "M2 12.5l5 5L17.5 7M9.5 15l2.5 2.5L22.5 7",
  restore: "M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4",
  thread: "M4 5h16v10H8l-4 4zM8 9h8M8 12h5",
  clip: "M16 7l-7.5 7.5a2 2 0 0 0 2.8 2.8L19 9.6a4 4 0 0 0-5.7-5.7l-8 8a6 6 0 0 0 8.5 8.5L20 14",
  star: "M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z",
  folder: "M3 6h6l2 2h10v11H3z",
  inbox: "M3 13l3-8h12l3 8v6H3zM3 13h5l1 2h6l1-2h5",
  sent: "M3 11l18-8-8 18-2-8z",
  filter: "M4 5h16l-6 8v6l-4-2v-4z",
  download: "M12 4v11m-5-5 5 5 5-5M5 20h14",
  image: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M15 9h.01",
  reply: "M9 14 4 9l5-5M4 9h10a6 6 0 0 1 6 6v4",
  replyAll: "M8 14 3 9l5-5M13 14 8 9l5-5M8 9h7a6 6 0 0 1 6 6v4",
  forward: "M15 14l5-5-5-5M20 9H10a6 6 0 0 0-6 6v4",
  compose: "M4 20h4L19 9l-4-4L4 16zM14 6l4 4",
  plus: "M12 5v14M5 12h14",
  via: "M6 4v7a4 4 0 0 0 4 4h9m-4-4 4 4-4 4",
  bell: "M6 16v-5a6 6 0 0 1 12 0v5l2 2H4zM10 21h4",
  select: "M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM8.5 12l2.5 2.5 4.5-5",
  check: "M5 12.5l4.5 4.5L19 7.5",
} as const;

export type IconName = keyof typeof paths;

/** `filled`: the shape filled as well as drawn (a set star). */
export function Icon({ name, size = 20, title, filled = false }: { name: IconName; size?: number; title?: string; filled?: boolean }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden={title ? undefined : "true"} role={title ? "img" : undefined}>
      {title && <title>{title}</title>}
      <path d={paths[name]} />
    </svg>
  );
}

export function folderIcon(name: string): IconName {
  const n = name.toLowerCase();
  if (n === "inbox") return "inbox";
  if (n === "sent") return "sent";
  if (n === "trash") return "trash";
  return "folder";
}
